module.exports = __webpack_public_path__ + "img/jldx.586657cc.jpg";